import { cva } from 'class-variance-authority';

import s from './CardHeader.module.css';

export const cardHeaderVariants = cva(s.header, {
  defaultVariants: {
    alignTop: false,
    prefixType: 'none',
    suffixType: 'element',
  },
  variants: {
    alignTop: {
      true: s['header--align-top'],
    },
    prefixType: {
      element: s['header--prefix-element'],
      icon: s['header--prefix-icon'],
      none: s['header--prefix-none'],
      text: s['header--prefix-text'],
    },
    suffixType: {
      element: s['header--suffix-element'],
      icon: s['header--suffix-icon'],
      none: s['header--suffix-none'],
      text: s['header--suffix-text'],
    },
  },
});
